// Shared UI primitives — Icon, base form controls, Modal, Btn, Empty, the Toast
// system, and the edit-guard context. React + haptics only.
import { useState, useRef, useEffect, useCallback, createContext, useContext } from "react";
import { haptic } from "../native";

export const APP_VERSION = "v3.7.1";

// App wordmark (inline base64).
export const PrabzoLogo = () => <img src="data:image/png;base64,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" alt="Prabzo" style={{width:"100%",height:"100%",objectFit:"contain"}}/>;


// ── ICONS ─────────────────────────────────────────────────────────────────────
export const Icon = ({name,size=20,className="",style})=>{
  const d={
    dashboard:<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>,
    clients:<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    attendance:<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    payments:<><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>,
    appointments:<><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    reports:<><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></>,
    gear:<><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
    logout:<><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
    plus:<><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
    edit:<><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
    trash:<><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></>,
    check:<polyline points="20 6 9 17 4 12"/>,
    x:<><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
    alert:<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
    user:<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></>,
    search:<><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
    calendar:<><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    convert:<><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>,
    eye:<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    swipe:<><path d="M5 12h14M12 5l7 7-7 7"/><path d="M5 8l-3 4 3 4"/></>,
    chevDown:<polyline points="6 9 12 15 18 9"/>,
    phone:<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>,
    star:<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>,
    receipt:<><path d="M14 2H6a2 2 0 0 0-2 2v16l3-2 3 2 3-2 3 2V8z"/><path d="M14 2v6h6"/><line x1="8" y1="13" x2="14" y2="13"/><line x1="8" y1="17" x2="14" y2="17"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} style={style}>{d[name]||null}</svg>;
};

// ── SEARCHABLE DROPDOWN ───────────────────────────────────────────────────────
export const SD = ({label,value,onChange,options,placeholder="Search...",theme})=>{
  const [open,setOpen]=useState(false);
  const [q,setQ]=useState("");
  const ref=useRef();
  const filtered=options.filter(o=>o.toLowerCase().includes(q.toLowerCase()));
  const isDark=theme?.dark;
  const bg=isDark?"#1e293b":"#fff";
  const borderC=isDark?"#334155":"#e5e7eb";
  const tc=isDark?"#f1f5f9":"#1f2937";
  const mc=isDark?"#94a3b8":"#6b7280";
  useEffect(()=>{
    const h=(e)=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener("mousedown",h);
    return ()=>document.removeEventListener("mousedown",h);
  },[]);
  return(
    <div className="flex flex-col gap-1 relative" ref={ref}>
      {label&&<label className="text-xs font-semibold uppercase tracking-wider" style={{color:mc}}>{label}</label>}
      <button type="button" onClick={()=>{setOpen(!open);setQ("");}}
        className="flex items-center justify-between px-4 py-2.5 rounded-xl text-sm border text-left transition-all"
        style={{background:isDark?"#0f172a":"#f9fafb",borderColor:borderC,color:value?tc:mc}}>
        <span className="truncate">{value||placeholder}</span>
        <Icon name="chevDown" size={14}/>
      </button>
      {open&&(
        <div className="absolute top-full left-0 right-0 z-50 rounded-xl shadow-2xl border mt-1 overflow-hidden" style={{background:bg,borderColor:borderC}}>
          <div className="p-2 border-b" style={{borderColor:borderC}}>
            <input autoFocus className="w-full px-3 py-1.5 rounded-lg text-sm focus:outline-none"
              style={{background:isDark?"#0f172a":"#f3f4f6",color:tc}}
              placeholder="Search..." value={q} onChange={e=>setQ(e.target.value)}/>
          </div>
          <div className="max-h-48 overflow-y-auto">
            {filtered.length===0
              ?<p className="text-xs text-center py-3" style={{color:mc}}>No results</p>
              :filtered.map(o=>(
                <button key={o} type="button" onClick={()=>{onChange(o);setOpen(false);setQ("");}}
                  className="w-full text-left px-4 py-2 text-sm"
                  style={{color:o===value?(theme?.primary||"#0f766e"):tc,background:o===value?(isDark?"#134e4a":"#f0fdfa"):"transparent"}}>
                  {o}
                </button>
              ))
            }
          </div>
        </div>
      )}
    </div>
  );
};

// ── BASE UI ───────────────────────────────────────────────────────────────────
export const Modal=({title,onClose,children,theme})=>{
  const isDark=theme?.dark;
  return(
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{background:"rgba(0,0,0,0.6)"}}>
      <div className="rounded-2xl shadow-2xl w-full max-w-lg flex flex-col" style={{background:isDark?"#1e293b":"#fff",maxHeight:"90vh"}}>
        {/* Sticky header */}
        <div className="flex items-center justify-between px-6 py-4 border-b flex-shrink-0 rounded-t-2xl" style={{background:isDark?"#1e293b":"#fff",borderColor:isDark?"#334155":"#f3f4f6"}}>
          <h2 className="text-lg font-bold" style={{fontFamily:"'Playfair Display',serif",color:isDark?"#f1f5f9":"#1f2937"}}>{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full" style={{color:isDark?"#94a3b8":"#6b7280"}}><Icon name="x" size={18}/></button>
        </div>
        {/* Scrollable body — scroll happens HERE, not on the page */}
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
};

export const Inp=({label,theme,error,...props})=>{
  const isDark=theme?.dark;
  return(
    <div className="flex flex-col gap-1">
      {label&&<label className="text-xs font-semibold uppercase tracking-wider" style={{color:isDark?"#94a3b8":"#6b7280"}}>{label}</label>}
      <input className="border rounded-xl px-4 py-2.5 text-sm focus:outline-none transition-all"
        style={{background:isDark?"#0f172a":"#f9fafb",borderColor:error?"#ef4444":(isDark?"#334155":"#e5e7eb"),color:isDark?"#f1f5f9":"#1f2937"}}
        {...props}/>
      {error&&<p className="text-xs text-red-500 mt-0.5">⚠ {error}</p>}
    </div>
  );
};

export const Sel=({label,children,theme,...props})=>{
  const isDark=theme?.dark;
  return(
    <div className="flex flex-col gap-1">
      {label&&<label className="text-xs font-semibold uppercase tracking-wider" style={{color:isDark?"#94a3b8":"#6b7280"}}>{label}</label>}
      <div className="relative">
        {/* appearance-none + custom chevron so every native <select> in the app matches
            the SD (searchable dropdown) component's icon instead of the browser's own arrow */}
        <select className="w-full border rounded-xl pl-4 pr-9 py-2.5 text-sm focus:outline-none transition-all appearance-none"
          style={{background:isDark?"#0f172a":"#f9fafb",borderColor:isDark?"#334155":"#e5e7eb",color:isDark?"#f1f5f9":"#1f2937"}}
          {...props}>{children}</select>
        <Icon name="chevDown" size={14} className="absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none" style={{color:isDark?"#94a3b8":"#6b7280"}}/>
      </div>
    </div>
  );
};

export const Btn=({children,variant="primary",className="",theme,onClick,style,...props})=>{
  const p=theme?.primary||"#0f766e";
  const isDark=theme?.dark;
  const vs={
    primary:{background:p,color:"#fff"},
    secondary:{background:isDark?"#334155":"#f3f4f6",color:isDark?"#f1f5f9":"#374151"},
    danger:{background:"#fef2f2",color:"#dc2626"},
    gold:{background:p,color:"#fff"},
    ghost:{background:"transparent",color:p,border:`1.5px solid ${p}`},
  };
  return <button {...props}
    onClick={onClick?(e)=>{haptic("light");onClick(e);}:undefined}
    className={`px-4 py-2.5 rounded-xl text-sm font-semibold transition-all active:scale-[0.97] flex items-center gap-2 ${className}`}
    style={{...(vs[variant]||vs.primary),...style}}>{children}</button>;
};

export const AddTimeBtn=({onClick,theme})=>{
  const p=theme?.primary||"#0f766e";
  return <button onClick={onClick} className="text-xs font-semibold px-3 py-2 rounded-xl border" style={{color:p,borderColor:p+"40",background:p+"10"}}>+ Add Time</button>;
};

export const Empty=({icon,message,cta,onCta,theme})=>(
  <div className="flex flex-col items-center justify-center py-20 gap-4" style={{color:theme?.dark?"#64748b":"#9ca3af"}}>
    <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{background:theme?.dark?"#1e293b":"#f9fafb"}}>
      <Icon name={icon} size={28}/>
    </div>
    <p className="text-sm">{message}</p>
    {cta&&<Btn onClick={onCta} theme={theme}><Icon name="plus" size={16}/>{cta}</Btn>}
  </div>
);

// ── TOAST SYSTEM ─────────────────────────────────────────────────────────────
export const ToastContext=createContext(null);
export const useToast=()=>useContext(ToastContext);

// ── EDIT GUARD ───────────────────────────────────────────────────────────────
// While an editing surface (a form / modal) is open, background sync must not
// overwrite the fields the user is editing. A form calls useFormGuard() (or
// renders <FormGuard active>) to increment a counter App checks before a
// non-forced sync.
export const EditGuardContext=createContext({pause(){},resume(){}});
export const useFormGuard=(active=true)=>{
  const g=useContext(EditGuardContext);
  useEffect(()=>{
    if(!active)return;
    g.pause();
    return ()=>g.resume();
  },[g,active]);
};
export const TOAST_ICONS={success:"✅",error:"❌",warning:"⚠️",info:"ℹ️"};
export const TOAST_COLORS={
  success:{bg:"#f0fdf4",border:"#86efac",text:"#166534"},
  error:{bg:"#fef2f2",border:"#fca5a5",text:"#991b1b"},
  warning:{bg:"#fffbeb",border:"#fde68a",text:"#92400e"},
  info:{bg:"#eff6ff",border:"#bfdbfe",text:"#1e40af"},
};
export const ToastProvider=({children})=>{
  const [toasts,setToasts]=useState([]);
  const show=useCallback((msg,type="success",duration=3000)=>{
    const id=Math.random().toString(36).slice(2);
    let added=false;
    setToasts(prev=>{
      if(prev.some(t=>t.msg===msg&&t.type===type))return prev;
      added=true;
      return [...prev,{id,msg,type}];
    });
    if(added&&(type==="success"||type==="error"||type==="warning"))haptic(type); // one buzz per visible toast
    setTimeout(()=>setToasts(prev=>prev.filter(t=>t.id!==id)),duration);
  },[]);
  const ICONS=TOAST_ICONS;
  const COLORS=TOAST_COLORS;
  return(
    <ToastContext.Provider value={show}>
      {children}
      <div className="fixed top-4 left-0 right-0 z-[9999] flex flex-col items-center gap-2 pointer-events-none px-4">
        {toasts.map(t=>{
          const c=COLORS[t.type]||COLORS.info;
          return(
            <div key={t.id} className="flex items-center gap-2 px-4 py-3 rounded-2xl shadow-lg text-sm font-semibold max-w-sm w-full pointer-events-auto"
              style={{background:c.bg,border:`1px solid ${c.border}`,color:c.text}}>
              <span>{ICONS[t.type]}</span>
              <span className="flex-1">{t.msg}</span>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
};

// ── INLINE CONFIRM BUTTON ─────────────────────────────────────────────────────
export const ConfirmButton=({label,confirmLabel="Sure?",onConfirm,className="",style={},danger=false,icon=null,size="sm"})=>{
  const [pending,setPending]=useState(false);
  const pad=size==="xs"?"px-2 py-1 text-xs":"px-3 py-1.5 text-xs";
  if(pending)return(
    <div className={`flex items-center gap-1 rounded-xl border ${pad} font-semibold`} style={{borderColor:"#e5e7eb",background:"#f9fafb"}}>
      <span className="text-gray-500 mr-1">{confirmLabel}</span>
      <button onClick={()=>{setPending(false);onConfirm();}}
        className="min-w-[28px] min-h-[28px] px-1.5 py-1 flex items-center justify-center rounded-lg font-bold text-sm text-white"
        style={{background:danger?"#ef4444":"#16a34a"}}>✓</button>
      <button onClick={()=>setPending(false)}
        className="min-w-[28px] min-h-[28px] px-1.5 py-1 flex items-center justify-center rounded-lg font-bold text-sm"
        style={{background:"#f3f4f6",color:"#6b7280"}}>✗</button>
    </div>
  );
  return(
    <button onClick={()=>setPending(true)} className={className} style={style}>
      {icon}{label}
    </button>
  );
};
